'use client';

import { initRuntimeErrorGuards } from './runtime-error-guards';

initRuntimeErrorGuards();

export default function RuntimeInit() {
    return null;
}
